import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';

@Component({
	selector: 'NgxRefresh',
	templateUrl: './ngxRefresh.component.html'
})
export class NgxRefresh {
	@Output() refreshPage = new EventEmitter();

	constructor() {

	}

	ngOnInit() {

	}

	onRefreshPage() {
		this.refreshPage.emit();
	}
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/shared/ngxGrid/ngxRefresh.component.ts